import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "dw-cluster-popup-group-feature__header" }
const _hoisted_2 = { class: "dw-cluster-popup-group-feature__badges" }
const _hoisted_3 = { class: "dw-cluster-popup-group-feature__title" }
const _hoisted_4 = { class: "title__row" }
const _hoisted_5 = { class: "dw-cluster-popup-group-feature-params" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("sup", null, "3", -1)
const _hoisted_7 = { class: "dw-cluster-popup-group-feature__container" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "container__divider" }, null, -1)
const _hoisted_12 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dw_badge = _resolveComponent("dw-badge")!
  const _component_dw_action_sequence_icon = _resolveComponent("dw-action-sequence-icon")!
  const _component_dw_wait_list_status = _resolveComponent("dw-wait-list-status")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dw-cluster-popup-group-feature", { 'dw-cluster-popup-group-feature--done': _ctx.isFeatureCompleted }]),
    style: _normalizeStyle({ borderColor: _ctx.computedColor })
  }, [
    (_ctx.featureEntity)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (Boolean(_ctx.featureEntity.waitListStatus))
                ? (_openBlock(), _createBlock(_component_dw_badge, {
                    key: 0,
                    class: "dw-badge--blue"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("ЛО")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.featureEntity.delaying)
                ? (_openBlock(), _createBlock(_component_dw_badge, {
                    key: 1,
                    class: "dw-badge--red-light"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Опаздывающий")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.featureEntity.downtimes.length)
                ? (_openBlock(), _createBlock(_component_dw_badge, {
                    key: 2,
                    class: "dw-badge--red-light"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Зафиксирован простой")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (_ctx.isCourierItem && _ctx.isFeatureCompleted)
                  ? (_openBlock(), _createBlock(_component_dw_action_sequence_icon, {
                      key: 0,
                      "action-sequence": _ctx.featureEntity.actionSequence
                    }, null, 8, ["action-sequence"]))
                  : _createCommentVNode("", true),
                (_ctx.featureEntity.type === 1)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      ((_ctx.featureEntity as DispatcherWorkplaceTake).notAssigned)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode("Неназначенный забор")
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode("Забор")
                          ], 64))
                    ], 64))
                  : (_ctx.featureEntity.type === 2)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        ((_ctx.featureEntity as DispatcherWorkplaceDelivery).notDelivered)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode("Невыданная доставка")
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode("Доставка")
                            ], 64))
                      ], 64))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createTextVNode(_toDisplayString(_ctx.featureEntity.weight ? _ctx.featureEntity.weight.toFixed(2) : 0) + " кг " + _toDisplayString(_ctx.featureEntity.volume ? _ctx.featureEntity.volume.toFixed(2) : 0) + " м", 1),
                _hoisted_6
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, [
              (_ctx.featureEntity.type === 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" №" + _toDisplayString((_ctx.featureEntity as DispatcherWorkplaceTake).orderNumber), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.featureEntity.type === 2)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" №" + _toDisplayString((_ctx.featureEntity as DispatcherWorkplaceDelivery).invoiceNumber), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, _toDisplayString(_ctx.featureEntity.companyName), 1),
            _createElementVNode("div", null, _toDisplayString(_ctx.featureEntity.fullAddress), 1),
            (_ctx.featureEntity.type === 1 && (_ctx.featureEntity as DispatcherWorkplaceTake).notAssigned)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Сектор: " + _toDisplayString(_ctx.featureEntity.sectorName || '-'), 1))
              : _createCommentVNode("", true),
            (_ctx.featureEntity.type === 1 && (_ctx.featureEntity as DispatcherWorkplaceTake).takenAt)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Забрано в: " + _toDisplayString((_ctx.featureEntity as DispatcherWorkplaceTake).takenAt), 1))
              : _createCommentVNode("", true),
            (_ctx.featureEntity.type === 2 && (_ctx.featureEntity as DispatcherWorkplaceDelivery).deliveredAt)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Доставлено в: " + _toDisplayString((_ctx.featureEntity as DispatcherWorkplaceDelivery).deliveredAt), 1))
              : _createCommentVNode("", true),
            (Boolean(_ctx.featureEntity.waitListStatus))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _hoisted_11,
                  _createVNode(_component_dw_wait_list_status, {
                    "showing-icon": (_ctx.featureEntity.waitListStatus as DispatcherWorkplaceRecordWaitListStatus).source !== 'МПК',
                    "wait-list-status": (_ctx.featureEntity.waitListStatus as DispatcherWorkplaceRecordWaitListStatus)
                  }, null, 8, ["showing-icon", "wait-list-status"]),
                  _createElementVNode("div", null, "Инициатор: " + _toDisplayString((_ctx.featureEntity.waitListStatus as DispatcherWorkplaceRecordWaitListStatus).user.name), 1),
                  (Boolean((_ctx.featureEntity.waitListStatus as DispatcherWorkplaceRecordWaitListStatus).value))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Дата изменения: " + _toDisplayString((_ctx.featureEntity.waitListStatus as DispatcherWorkplaceRecordWaitListStatus).value), 1))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ])
        ], 64))
      : _createCommentVNode("", true)
  ], 6))
}